// Avatar — 1:1 port of legacy `src/ui/Primitives.jsx:128–136`.
// Initials derived from `name` (split on whitespace/dot, first letter of each, slice 2, uppercase).
// Falls back to `'?'` when `name` is undefined or empty.
export interface AvatarProps {
  name?: string;
  size?: number;
}

export function Avatar({ name, size = 22 }: AvatarProps) {
  const ini = name
    ? name
        .split(/[\s.]+/)
        .filter(Boolean)
        .map((x) => x[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : '?';
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'var(--bg-3)',
        color: 'var(--fg-2)',
        fontSize: Math.max(9, size * 0.42),
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
      }}
    >
      {ini}
    </div>
  );
}
